import React, { useEffect, useState } from 'react';
import * as PouchDB from 'pouchdb';
import PouchDBAuthentication from 'pouchdb-authentication';
import { getMontrealDate } from '../../utils/GetISOlocalDate';
PouchDB.default.plugin(PouchDBAuthentication)

var URL_DATABASE = process.env.REACT_APP_DB_URL
var db = new PouchDB.default(URL_DATABASE, {skip_setup: true});

export default function Users() {

    const createUser = async (event: any) => {
        event.preventDefault();
        let username = event.target.elements["username"].value
        let password = event.target.elements["password"].value
        let role = event.target.elements["role"].value
        
        await db.signUp(username, password, 
          {metadata: {created: getMontrealDate()}, roles: [role]}, 
          function (err, response) {
            if (err) {
              console.log(err)
              if (err.name === 'conflict') {
                // "batman" already exists, choose another username
              } else if (err.name === 'forbidden') {
                // invalid username
              } else {
                // HTTP error, cosmic rays, etc.
              }
            }
          });

        window.location.reload()
    }

    return (
        <>
            <h1>Créer un compte</h1>
            <form onSubmit={createUser}>
                <div className="container">
                    <label htmlFor="username"><b>Nom d'utilisateur</b></label>
                    <input type="text" placeholder="Nom d'utilisateur" name="username" required/>

                    <label htmlFor="password"><b>Mot de passe</b></label>
                    <input type="password" placeholder="Mot de passe" name="password" required/>

                    <label htmlFor="role"><b>Role</b></label>
                    <select name='role' defaultValue={"user"}>
                      <option value="user">user</option>
                      <option value="website_admin">website_admin</option>
                    </select>

                    <input type="submit" value="Créer compte"/>
                </div>
            </form>
        </>
    )
}